import { render } from "./CollectorsVersionPage.vue?vue&type=template&id=3de5ccf1&scoped=true&ts=true"
import script from "./CollectorsVersionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./CollectorsVersionPage.vue?vue&type=script&lang=ts&setup=true"

import "./CollectorsVersionPage.vue?vue&type=style&index=0&id=3de5ccf1&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de5ccf1"],['__file',"src/pages/settings/pages/collectorsVersion/CollectorsVersionPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3de5ccf1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3de5ccf1', __exports__)) {
    api.reload('3de5ccf1', __exports__)
  }
  
  module.hot.accept("./CollectorsVersionPage.vue?vue&type=template&id=3de5ccf1&scoped=true&ts=true", () => {
    api.rerender('3de5ccf1', render)
  })

}


export default __exports__